import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { CopilotProvider } from './context/CopilotContext';
import Routines from './pages/Routines';
import Analytics from './pages/Analytics';
import Approvals from './pages/Approvals';import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import Dashboard from './pages/Dashboard';
import SalesDistribution from './pages/SalesDistribution';
import MasterData from './pages/MasterData';
import Company from './pages/Company';
import Assignments from './pages/Assignments';
import BulkUpload from './pages/BulkUpload';
import Finance from './pages/Finance';
import FinanceAssignments from './pages/FinanceAssignments';
import Controlling from './pages/Controlling';
import ControllingAssignments from './pages/ControllingAssignments';
import CostElements from './pages/CostElements';
import MaterialManagement from './pages/MaterialManagement';
import PurchasingManagement from './pages/PurchasingManagement';
import MaterialManagementAssignments from './pages/MaterialManagementAssignments';
import EWM from './pages/EWM';
import EWMAssignments from './pages/EWMAssignments';
// HCM Module Imports
import HCMDashboard from './pages/HCM/index';
import EnterpriseStructure from './pages/HCM/Configuration/EnterpriseStructure';
import PayScaleConfig from './pages/HCM/Configuration/PayScaleConfig';
import WageTypesConfig from './pages/HCM/Configuration/WageTypes';
import EmployeeIDConfig from './pages/HCM/Configuration/EmployeeIDConfig';

// Asset Accounting (FI-AA)
import AssetList from './pages/AssetManagement/AssetList';
import AssetClasses from './pages/AssetManagement/AssetClasses';
import AssetView from './pages/AssetManagement/AssetView';
import DepreciationRun from './pages/AssetManagement/DepreciationRun';

// Quality Management (QM)
import QualityDashboard from './pages/Quality/QualityDashboard';
import InspectionTypes from './pages/Quality/InspectionTypes';
import InspectionPlans from './pages/Quality/InspectionPlans';
import InspectionLots from './pages/Quality/InspectionLots';
import QualityNotifications from './pages/Quality/QualityNotifications';
import QualityCertificates from './pages/Quality/QualityCertificates';
import PMDashboard from './pages/PlantMaintenance/PMDashboard';
import FunctionalLocations from './pages/PlantMaintenance/FunctionalLocations';
import PMEquipment from './pages/PlantMaintenance/Equipment';
import PMNotifications from './pages/PlantMaintenance/Notifications';
import WorkOrders from './pages/PlantMaintenance/WorkOrders';
import PMTaskLists from './pages/PlantMaintenance/TaskLists';
import MaintenancePlans from './pages/PlantMaintenance/MaintenancePlans';
import MeasuringPoints from './pages/PlantMaintenance/MeasuringPoints';
// HCM Organizational Management Imports
import OMDashboard from './pages/HCM/OrgManagement/index';
import OrgUnits from './pages/HCM/OrgManagement/OrgUnits';
import Jobs from './pages/HCM/OrgManagement/Jobs';
import OMPositions from './pages/HCM/OrgManagement/Positions';
import OrgChart from './pages/HCM/OrgManagement/OrgChart';
// HCM Time Management Imports
import TimeManagementDashboard from './pages/HCM/TimeManagement/index';
import TimeManagementConfig from './pages/HCM/TimeManagement/Config';
import Absences from './pages/HCM/TimeManagement/Absences';
import Attendances from './pages/HCM/TimeManagement/Attendances';
import EmployeeQuotas from './pages/HCM/TimeManagement/EmployeeQuotas';
// HCM Payroll Imports
import PayrollDashboard from './pages/HCM/Payroll/index';
import PayrollRuns from './pages/HCM/Payroll/PayrollRuns';
import PayrollResults from './pages/HCM/Payroll/PayrollResults';
import PayrollConfig from './pages/HCM/Payroll/PayrollConfig';
import BankTransfers from './pages/HCM/Payroll/BankTransfers';
import GLMapping from './pages/HCM/Payroll/GLMapping';
import GLPosting from './pages/HCM/Payroll/GLPosting';
import VendorMaster from './pages/VendorMaster';
import Vendors from './pages/Vendors';
import VendorForm from './pages/VendorForm';
import MaterialMaster from './pages/MaterialMaster';
import CustomerMaster from './pages/CustomerMaster';
import CustomerAccountGroup from './pages/CustomerAccountGroup';
import CustomerNumberRange from './pages/CustomerNumberRange';
import CustomerAccountGroupConfig from './pages/CustomerAccountGroupConfig';
import CustomerPartnerFunction from './pages/CustomerPartnerFunction';
import CustomerAccountGroupPartnerFunction from './pages/CustomerAccountGroupPartnerFunction';
import CustomerPartnerDeterminationProcedure from './pages/CustomerPartnerDeterminationProcedure';
import CustomerPDPPartnerFunction from './pages/CustomerPDPPartnerFunction';
import CustomerAccountGroupPDP from './pages/CustomerAccountGroupPDP';
import CustomerSalesDistrict from './pages/CustomerSalesDistrict';
import CustomerGroupPage from './pages/CustomerGroupPage';
import CustomerDeliveryPriority from './pages/CustomerDeliveryPriority';
import CustomerTermsOfPayment from './pages/CustomerTermsOfPayment';
import CustomerIncoterms from './pages/CustomerIncoterms';
import CustomerShippingConditions from './pages/CustomerShippingConditions';
import CustomerCreation from './pages/CustomerCreation';
import ViewCustomers from './pages/ViewCustomers';
import ViewCustomer from './pages/ViewCustomer';
import EditCustomer from './pages/EditCustomer';
import MaterialCreation from './pages/MaterialCreation';
import ViewMaterials from './pages/ViewMaterials';
import MaterialView from './pages/MaterialView';
import MaterialEdit from './pages/MaterialEdit';
import UnitOfMeasure from './pages/UnitOfMeasure';
import MaterialGroup from './pages/MaterialGroup';
import ItemCategoryGroup from './pages/ItemCategoryGroup';
import WeightUnit from './pages/WeightUnit';
import TransportationGroup from './pages/TransportationGroup';
import LoadingGroup from './pages/LoadingGroup';
import AvailabilityCheck from './pages/AvailabilityCheck';
import AccountAssignmentGroup from './pages/AccountAssignmentGroup';
import MRPType from './pages/MRPType';
import MRPController from './pages/MRPController';
import LotSize from './pages/LotSize';
import LotSizingProcedure from './pages/LotSizingProcedure';
import LotSizeIndicator from './pages/LotSizeIndicator';
import ProcurementType from './pages/ProcurementType';
import SchedulingMarginKey from './pages/SchedulingMarginKey';
import PeriodIndicator from './pages/PeriodIndicator';
import ForecastModel from './pages/ForecastModel';
import SelectionProcedure from './pages/SelectionProcedure';
import TaskListUsage from './pages/TaskListUsage';
import ValuationCategory from './pages/ValuationCategory';
import AccountCategoryReference from './pages/AccountCategoryReference';
import ValuationType from './pages/ValuationType';
import ValuationTypeCategoryAssignment from './pages/ValuationTypeCategoryAssignment';
import ValuationClass from './pages/ValuationClass';
import NumberRange from './pages/NumberRange';
import P2PDashboard from './pages/P2PDashboard';
// import PRCreate from './pages/PRCreate';  // Old file backed up
import PRCreateComplete from './pages/PRCreateComplete';
import PRList from './pages/PRList';
import PRView from './pages/PRView';
import PREdit from './pages/PREdit';
import RFQCreateComplete from './pages/RFQCreateComplete';
import RFQList from './pages/RFQList';
import RFQView from './pages/RFQView';
import RFQEdit from './pages/RFQEdit';
import POList from './pages/POList';
import POCreateComplete from './pages/POCreateComplete';
import POEdit from './pages/POEdit';
import POViewComplete from './pages/POViewComplete';
import GRList from './pages/GRList';
import GRView from './pages/GRView';
import GRCreate from './pages/GRCreate';
import IRList from './pages/IRList';
import IRView from './pages/IRView';
import IRCreate from './pages/IRCreate';
import SESList from './pages/SESList';
import SESView from './pages/SESView';
import SESCreate from './pages/SESCreate';
import InventoryDashboard from './pages/InventoryDashboard';
import StockOverview from './pages/StockOverview';
import MaterialDocuments from './pages/MaterialDocuments';
import InitialStockPosting from './pages/InitialStockPosting';
import StockTransfer from './pages/StockTransfer';
import GRIRReconciliation from './pages/GRIRReconciliation';
import AccountingDocuments from './pages/AccountingDocuments';
import ConditionTypes from './pages/ConditionTypes';
import ConditionRecords from './pages/ConditionRecords';
import PricingSimulator from './pages/PricingSimulator';
import AccessSequences from './pages/AccessSequences';
import ConditionTables from './pages/ConditionTables';
import PricingProcedures from './pages/PricingProcedures';
import SalesOrderList from './pages/SalesOrderList';
import SalesOrderCreate from './pages/SalesOrderCreate';
import SalesOrderView from './pages/SalesOrderView';
import DeliveryList from './pages/DeliveryList';
import DeliveryCreate from './pages/DeliveryCreate';
import DeliveryView from './pages/DeliveryView';
import BillingList from './pages/BillingList';
import BillingCreate from './pages/BillingCreate';
import BillingView from './pages/BillingView';
import CustomerOpenItems from './pages/CustomerOpenItems';
import PaymentList from './pages/PaymentList';
import PaymentCreate from './pages/PaymentCreate';
import PaymentView from './pages/PaymentView';
import ARAgingReport from './pages/ARAgingReport';
import CreditExposure from './pages/CreditExposure';
import CustomerCreditView from './pages/CustomerCreditView';
import ATPCheck from './pages/ATPCheck';
import ReturnsOrderList from './pages/ReturnsOrderList';
import ReturnsOrderCreate from './pages/ReturnsOrderCreate';
import ReturnsOrderView from './pages/ReturnsOrderView';
import CreditMemoList from './pages/CreditMemoList';
import CreditMemoView from './pages/CreditMemoView';
import InquiryList from './pages/InquiryList';
import InquiryCreate from './pages/InquiryCreate';
import InquiryView from './pages/InquiryView';
import InquiryEdit from './pages/InquiryEdit';
import QuotationList from './pages/QuotationList';
import QuotationCreate from './pages/QuotationCreate';
import QuotationView from './pages/QuotationView';
import QuotationEdit from './pages/QuotationEdit';
import OTCDashboard from './pages/OTCDashboard';
import VendorPaymentList from './pages/VendorPaymentList';
import VendorPaymentView from './pages/VendorPaymentView';
import PaymentProposalCreate from './pages/PaymentProposalCreate';
import VendorOpenItems from './pages/VendorOpenItems';
import APAgingReport from './pages/APAgingReport';
// P2 Module Imports
import VendorQuotationList from './pages/VendorQuotationList';
import QuoteComparisonView from './pages/QuoteComparisonView';
import ReleaseStrategyList from './pages/ReleaseStrategyList';
import ApprovalInbox from './pages/ApprovalInbox';
import VendorReturnList from './pages/VendorReturnList';
import VendorReturnCreate from './pages/VendorReturnCreate';
import VendorReturnDetail from './pages/VendorReturnDetail';
import ShipmentList from './pages/ShipmentList';
import ShipmentCreate from './pages/ShipmentCreate';
import ShipmentView from './pages/ShipmentView';
import PickListPage from './pages/PickListPage';
import PickListCreate from './pages/PickListCreate';
import PickListView from './pages/PickListView';
import PackingPage from './pages/PackingPage';
// OTC Enhancement Module Imports
import BillingBlocksPage from './pages/BillingBlocksPage';
import SalesPerformancePage from './pages/SalesPerformancePage';
import WavePickingPage from './pages/WavePickingPage';
import ProfitabilityPage from './pages/ProfitabilityPage';
import PODPage from './pages/PODPage';
import RouteSchedulingPage from './pages/RouteSchedulingPage';
import MilestoneBillingPage from './pages/MilestoneBillingPage';
import IntercompanyBillingPage from './pages/IntercompanyBillingPage';
import P2PDocumentTypes from './pages/P2PDocumentTypes';
import NumberRanges from './pages/Config/NumberRanges';
import FIDocumentTypes from './pages/FIDocumentTypes';
import FINumberRanges from './pages/FINumberRanges';
import JournalVoucherList from './pages/JournalVoucherList';
import JournalVoucherCreate from './pages/JournalVoucherCreate';
import JournalVoucherView from './pages/JournalVoucherView';
import GLLineItems from './pages/GLLineItems';
import TrialBalance from './pages/TrialBalance';
import CostCenterHierarchy from './pages/CostCenterHierarchy';
import ARAPOpenItems from './pages/ARAPOpenItems';
import CustomFieldManager from './pages/CustomFieldManager';
import WorkflowManager from './pages/WorkflowManager';
import DocTypeBuilder from './pages/DocTypeBuilder';
import ReportBuilder from './pages/ReportBuilder';
import ClientScriptManager from './pages/ClientScriptManager';
import PrintFormatDesigner from './pages/PrintFormatDesigner';
import AccessControl from './pages/AccessControl';
import AuditLog from './pages/AuditLog';
import SelfServicePortal from './pages/SelfServicePortal';
import DynamicDocList from './pages/DynamicDocList';
import EmployeeList from './pages/HCM/PersonnelAdmin/EmployeeList';
import EmployeeCreate from './pages/HCM/PersonnelAdmin/EmployeeCreate';
import EmployeeView from './pages/HCM/PersonnelAdmin/EmployeeView';
import PersonnelActions from './pages/HCM/PersonnelAdmin/PersonnelActions';
// PS Module Imports
import PSDashboard from './pages/PS/index';
import ProjectProfiles from './pages/PS/Config/ProjectProfiles';
import WBSProfiles from './pages/PS/Config/WBSProfiles';
import NetworkProfiles from './pages/PS/Config/NetworkProfiles';
import StatusProfiles from './pages/PS/Config/StatusProfiles';
import PlanningProfiles from './pages/PS/Config/PlanningProfiles';
import BudgetProfiles from './pages/PS/Config/BudgetProfiles';
import ProjectList from './pages/PS/Projects/ProjectList';
import ProjectForm from './pages/PS/Projects/ProjectForm';
import ProjectDetail from './pages/PS/Projects/ProjectDetail';
import ProjectTemplates from './pages/PS/Projects/ProjectTemplates';
import PlanningDashboard from './pages/PS/Planning/PlanningDashboard';
import BudgetManagement from './pages/PS/Planning/BudgetManagement';
import CostPlanning from './pages/PS/Planning/CostPlanning';
import PlanActualComparison from './pages/PS/Planning/PlanActualComparison';
import PSCommitments from './pages/PS/Planning/Commitments';
// PS Phase 3: Execution
import ExecutionDashboard from './pages/PS/Execution/ExecutionDashboard';
import PSNetworks from './pages/PS/Execution/Networks';
import PSActivities from './pages/PS/Execution/Activities';
import PSConfirmations from './pages/PS/Execution/Confirmations';
import PSMaterials from './pages/PS/Execution/Materials';
// PS Phase 4: Closing & Reporting
import ClosingDashboard from './pages/PS/Closing/ClosingDashboard';
import PeriodLocks from './pages/PS/Closing/PeriodLocks';
import Settlement from './pages/PS/Closing/Settlement';
import WIPCalculation from './pages/PS/Closing/WIPCalculation';
import ProjectClosure from './pages/PS/Closing/ProjectClosure';
import PSReports from './pages/PS/Reports/Reports';
import InvestmentPrograms from './pages/PS/InvestmentPrograms/InvestmentPrograms';
import InvestmentProgramDetail from './pages/PS/InvestmentPrograms/InvestmentProgramDetail';
// PS-FI Integration
import PSFIDashboard from './pages/PS/Integration/PSFIDashboard';
import AccountDetermination from './pages/PS/Integration/AccountDetermination';
import FIDocuments from './pages/PS/Integration/FIDocuments';
import WIPPosting from './pages/PS/Integration/WIPPosting';
// Manufacturing (PP) Module Imports
import ManufacturingDashboard from './pages/Manufacturing/index';
import WorkCenters from './pages/Manufacturing/WorkCenters';
import BOMs from './pages/Manufacturing/BOMs';
import Routings from './pages/Manufacturing/Routings';
import MfgNumberRanges from './pages/Manufacturing/NumberRanges';
import ProductionOrderList from './pages/Manufacturing/ProductionOrders/ProductionOrderList';
import ProductionOrderForm from './pages/Manufacturing/ProductionOrders/ProductionOrderForm';
import ProductionOrderDetail from './pages/Manufacturing/ProductionOrders/ProductionOrderDetail';
import {Toaster} from './components/ui/sonner';
import { Toaster as HotToaster } from 'react-hot-toast';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CopilotProvider>
        <div className="App">
          <Routes>
            {/* Public route - Login */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* All other routes are protected */}
            <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
            <Route path="/routines" element={<ProtectedRoute><Routines /></ProtectedRoute>} />
            <Route path="/approvals" element={<ProtectedRoute><Approvals /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute><Analytics view="overview" /></ProtectedRoute>} />
            <Route path="/analytics/p2p" element={<ProtectedRoute><Analytics view="p2p" /></ProtectedRoute>} />
            <Route path="/analytics/otc" element={<ProtectedRoute><Analytics view="otc" /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/sales-distribution" element={<ProtectedRoute><SalesDistribution /></ProtectedRoute>} />
            <Route path="/master-data" element={<ProtectedRoute><MasterData /></ProtectedRoute>} />
            <Route path="/company" element={<ProtectedRoute><Company /></ProtectedRoute>} />
            <Route path="/assignments" element={<ProtectedRoute><Assignments /></ProtectedRoute>} />
            <Route path="/bulk-upload" element={<ProtectedRoute><BulkUpload /></ProtectedRoute>} />
            <Route path="/finance" element={<ProtectedRoute><Finance /></ProtectedRoute>} />
            <Route path="/finance/fi-document-types" element={<ProtectedRoute><FIDocumentTypes /></ProtectedRoute>} />
            <Route path="/finance/fi-number-ranges" element={<ProtectedRoute><FINumberRanges /></ProtectedRoute>} />
            <Route path="/finance/journal-vouchers" element={<ProtectedRoute><JournalVoucherList /></ProtectedRoute>} />
            <Route path="/finance/journal-vouchers/create" element={<ProtectedRoute><JournalVoucherCreate /></ProtectedRoute>} />
            <Route path="/finance/journal-vouchers/:document_number/:company_code_id/:fiscal_year" element={<ProtectedRoute><JournalVoucherView /></ProtectedRoute>} />
            <Route path="/finance/gl-line-items" element={<ProtectedRoute><GLLineItems /></ProtectedRoute>} />
            <Route path="/finance/trial-balance" element={<ProtectedRoute><TrialBalance /></ProtectedRoute>} />
            <Route path="/controlling/cost-center-hierarchy" element={<ProtectedRoute><CostCenterHierarchy /></ProtectedRoute>} />
            <Route path="/ar/customers/:partner_id/open-items" element={<ProtectedRoute><ARAPOpenItems mode="AR" /></ProtectedRoute>} />
            <Route path="/ap/vendors/:partner_id/open-items" element={<ProtectedRoute><ARAPOpenItems mode="AP" /></ProtectedRoute>} />
            <Route path="/config/custom-fields" element={<ProtectedRoute><CustomFieldManager /></ProtectedRoute>} />
            <Route path="/config/workflows" element={<ProtectedRoute><WorkflowManager /></ProtectedRoute>} />
            <Route path="/config/doctype-builder" element={<ProtectedRoute><DocTypeBuilder /></ProtectedRoute>} />
            <Route path="/config/report-builder" element={<ProtectedRoute><ReportBuilder /></ProtectedRoute>} />
            <Route path="/config/client-scripts" element={<ProtectedRoute><ClientScriptManager /></ProtectedRoute>} />
            <Route path="/config/print-formats" element={<ProtectedRoute><PrintFormatDesigner /></ProtectedRoute>} />
            <Route path="/access-control" element={<ProtectedRoute><AccessControl /></ProtectedRoute>} />
            <Route path="/audit-log" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
            <Route path="/portal" element={<ProtectedRoute><SelfServicePortal /></ProtectedRoute>} />
            <Route path="/doc/:doctypeName" element={<ProtectedRoute><DynamicDocList /></ProtectedRoute>} />
            <Route path="/finance-assignments" element={<ProtectedRoute><FinanceAssignments /></ProtectedRoute>} />
            <Route path="/controlling" element={<ProtectedRoute><Controlling /></ProtectedRoute>} />
            <Route path="/controlling/cost-elements" element={<ProtectedRoute><CostElements /></ProtectedRoute>} />
            <Route path="/controlling-assignments" element={<ProtectedRoute><ControllingAssignments /></ProtectedRoute>} />
            <Route path="/material-management" element={<ProtectedRoute><MaterialManagement /></ProtectedRoute>} />
            <Route path="/purchasing-management" element={<ProtectedRoute><PurchasingManagement /></ProtectedRoute>} />
            <Route path="/material-management-assignments" element={<ProtectedRoute><MaterialManagementAssignments /></ProtectedRoute>} />
          <Route path="/ewm" element={<ProtectedRoute><EWM /></ProtectedRoute>} />
          <Route path="/ewm-assignments" element={<ProtectedRoute><EWMAssignments /></ProtectedRoute>} />
          
          {/* HCM Module Routes */}
          <Route path="/hcm" element={<ProtectedRoute><HCMDashboard /></ProtectedRoute>} />
          
          {/* HCM Configuration Routes */}
          <Route path="/hcm/config/enterprise-structure" element={<ProtectedRoute><EnterpriseStructure /></ProtectedRoute>} />
          <Route path="/hcm/config/enterprise-structure/personnel-areas" element={<ProtectedRoute><EnterpriseStructure /></ProtectedRoute>} />
          <Route path="/hcm/config/enterprise-structure/personnel-subareas" element={<ProtectedRoute><EnterpriseStructure /></ProtectedRoute>} />
          <Route path="/hcm/config/enterprise-structure/employee-groups" element={<ProtectedRoute><EnterpriseStructure /></ProtectedRoute>} />
          <Route path="/hcm/config/enterprise-structure/employee-subgroups" element={<ProtectedRoute><EnterpriseStructure /></ProtectedRoute>} />
          <Route path="/hcm/config/pay-scale" element={<ProtectedRoute><PayScaleConfig /></ProtectedRoute>} />
          <Route path="/hcm/config/pay-scale/pay-scale-types" element={<ProtectedRoute><PayScaleConfig /></ProtectedRoute>} />
          <Route path="/hcm/config/pay-scale/pay-scale-areas" element={<ProtectedRoute><PayScaleConfig /></ProtectedRoute>} />
          <Route path="/hcm/config/pay-scale/pay-scale-groups" element={<ProtectedRoute><PayScaleConfig /></ProtectedRoute>} />
          <Route path="/hcm/config/pay-scale/pay-scale-levels" element={<ProtectedRoute><PayScaleConfig /></ProtectedRoute>} />
          <Route path="/hcm/config/wage-types" element={<ProtectedRoute><WageTypesConfig /></ProtectedRoute>} />
          <Route path="/hcm/config/employee-id" element={<ProtectedRoute><EmployeeIDConfig /></ProtectedRoute>} />

          {/* Asset Accounting (FI-AA) */}
          <Route path="/assets" element={<ProtectedRoute><AssetList /></ProtectedRoute>} />
          <Route path="/assets/asset-classes" element={<ProtectedRoute><AssetClasses /></ProtectedRoute>} />
          <Route path="/assets/depreciation-run" element={<ProtectedRoute><DepreciationRun /></ProtectedRoute>} />
          <Route path="/assets/:assetNumber" element={<ProtectedRoute><AssetView /></ProtectedRoute>} />

          {/* Quality Management (QM) */}
          <Route path="/quality" element={<ProtectedRoute><QualityDashboard /></ProtectedRoute>} />
          <Route path="/quality/inspection-lots" element={<ProtectedRoute><InspectionLots /></ProtectedRoute>} />
          <Route path="/quality/inspection-plans" element={<ProtectedRoute><InspectionPlans /></ProtectedRoute>} />
          <Route path="/quality/inspection-types" element={<ProtectedRoute><InspectionTypes /></ProtectedRoute>} />
          <Route path="/quality/notifications" element={<ProtectedRoute><QualityNotifications /></ProtectedRoute>} />
          <Route path="/quality/certificates" element={<ProtectedRoute><QualityCertificates /></ProtectedRoute>} />

          {/* Plant Maintenance (PM) */}
          <Route path="/maintenance" element={<ProtectedRoute><PMDashboard /></ProtectedRoute>} />
          <Route path="/maintenance/equipment" element={<ProtectedRoute><PMEquipment /></ProtectedRoute>} />
          <Route path="/maintenance/functional-locations" element={<ProtectedRoute><FunctionalLocations /></ProtectedRoute>} />
          <Route path="/maintenance/notifications" element={<ProtectedRoute><PMNotifications /></ProtectedRoute>} />
          <Route path="/maintenance/orders" element={<ProtectedRoute><WorkOrders /></ProtectedRoute>} />
          <Route path="/maintenance/task-lists" element={<ProtectedRoute><PMTaskLists /></ProtectedRoute>} />
          <Route path="/maintenance/maintenance-plans" element={<ProtectedRoute><MaintenancePlans /></ProtectedRoute>} />
          <Route path="/maintenance/measuring-points" element={<ProtectedRoute><MeasuringPoints /></ProtectedRoute>} />

          {/* HCM Personnel Administration Routes */}
          <Route path="/hcm/employees" element={<ProtectedRoute><EmployeeList /></ProtectedRoute>} />
          <Route path="/hcm/employees/create" element={<ProtectedRoute><EmployeeCreate /></ProtectedRoute>} />
          <Route path="/hcm/employees/:employee_id" element={<ProtectedRoute><EmployeeView /></ProtectedRoute>} />
          <Route path="/hcm/personnel-actions" element={<ProtectedRoute><PersonnelActions /></ProtectedRoute>} />
          
          {/* HCM Organizational Management Routes */}
          <Route path="/hcm/om" element={<ProtectedRoute><OMDashboard /></ProtectedRoute>} />
          <Route path="/hcm/om/org-units" element={<ProtectedRoute><OrgUnits /></ProtectedRoute>} />
          <Route path="/hcm/om/jobs" element={<ProtectedRoute><Jobs /></ProtectedRoute>} />
          <Route path="/hcm/om/positions" element={<ProtectedRoute><OMPositions /></ProtectedRoute>} />
          <Route path="/hcm/om/org-chart" element={<ProtectedRoute><OrgChart /></ProtectedRoute>} />
          
          {/* HCM Time Management Routes */}
          <Route path="/hcm/time" element={<ProtectedRoute><TimeManagementDashboard /></ProtectedRoute>} />
          <Route path="/hcm/time/config" element={<ProtectedRoute><TimeManagementConfig /></ProtectedRoute>} />
          <Route path="/hcm/time/absences" element={<ProtectedRoute><Absences /></ProtectedRoute>} />
          <Route path="/hcm/time/attendances" element={<ProtectedRoute><Attendances /></ProtectedRoute>} />
          <Route path="/hcm/time/employee-quotas" element={<ProtectedRoute><EmployeeQuotas /></ProtectedRoute>} />
          
          {/* HCM Payroll Routes */}
          <Route path="/hcm/payroll" element={<ProtectedRoute><PayrollDashboard /></ProtectedRoute>} />
          <Route path="/hcm/payroll/runs" element={<ProtectedRoute><PayrollRuns /></ProtectedRoute>} />
          <Route path="/hcm/payroll/results" element={<ProtectedRoute><PayrollResults /></ProtectedRoute>} />
          <Route path="/hcm/payroll/config" element={<ProtectedRoute><PayrollConfig /></ProtectedRoute>} />
          <Route path="/hcm/payroll/bank-transfers" element={<ProtectedRoute><BankTransfers /></ProtectedRoute>} />
          <Route path="/hcm/payroll/gl-mapping" element={<ProtectedRoute><GLMapping /></ProtectedRoute>} />
          <Route path="/hcm/payroll/gl-posting" element={<ProtectedRoute><GLPosting /></ProtectedRoute>} />
          
          {/* Project Systems (PS) Module Routes */}
          <Route path="/ps" element={<ProtectedRoute><PSDashboard /></ProtectedRoute>} />
          <Route path="/ps/config/project-profiles" element={<ProtectedRoute><ProjectProfiles /></ProtectedRoute>} />
          <Route path="/ps/config/wbs-profiles" element={<ProtectedRoute><WBSProfiles /></ProtectedRoute>} />
          <Route path="/ps/config/network-profiles" element={<ProtectedRoute><NetworkProfiles /></ProtectedRoute>} />
          <Route path="/ps/config/status-profiles" element={<ProtectedRoute><StatusProfiles /></ProtectedRoute>} />
          <Route path="/ps/config/planning-profiles" element={<ProtectedRoute><PlanningProfiles /></ProtectedRoute>} />
          <Route path="/ps/projects" element={<ProtectedRoute><ProjectList /></ProtectedRoute>} />
          <Route path="/ps/projects/create" element={<ProtectedRoute><ProjectForm /></ProtectedRoute>} />
          <Route path="/ps/projects/:projectId" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
          <Route path="/ps/projects/:projectId/edit" element={<ProtectedRoute><ProjectForm /></ProtectedRoute>} />
          <Route path="/ps/wbs-elements" element={<ProtectedRoute><ProjectList /></ProtectedRoute>} />
          <Route path="/ps/templates" element={<ProtectedRoute><ProjectTemplates /></ProtectedRoute>} />
          
          {/* PS Phase 2: Planning & Budgeting */}
          <Route path="/ps/config/budget-profiles" element={<ProtectedRoute><BudgetProfiles /></ProtectedRoute>} />
          <Route path="/ps/planning" element={<ProtectedRoute><PlanningDashboard /></ProtectedRoute>} />
          <Route path="/ps/planning/budget" element={<ProtectedRoute><BudgetManagement /></ProtectedRoute>} />
          <Route path="/ps/planning/budget/new" element={<ProtectedRoute><BudgetManagement /></ProtectedRoute>} />
          <Route path="/ps/planning/cost-plans" element={<ProtectedRoute><CostPlanning /></ProtectedRoute>} />
          <Route path="/ps/planning/comparison" element={<ProtectedRoute><PlanActualComparison /></ProtectedRoute>} />
          <Route path="/ps/planning/commitments" element={<ProtectedRoute><PSCommitments /></ProtectedRoute>} />
          
          {/* PS Phase 3: Execution */}
          <Route path="/ps/execution" element={<ProtectedRoute><ExecutionDashboard /></ProtectedRoute>} />
          <Route path="/ps/execution/networks" element={<ProtectedRoute><PSNetworks /></ProtectedRoute>} />
          <Route path="/ps/execution/activities" element={<ProtectedRoute><PSActivities /></ProtectedRoute>} />
          <Route path="/ps/execution/confirmations" element={<ProtectedRoute><PSConfirmations /></ProtectedRoute>} />
          <Route path="/ps/execution/materials" element={<ProtectedRoute><PSMaterials /></ProtectedRoute>} />
          
          {/* PS Phase 4: Closing & Reporting */}
          <Route path="/ps/closing" element={<ProtectedRoute><ClosingDashboard /></ProtectedRoute>} />
          <Route path="/ps/closing/periods" element={<ProtectedRoute><PeriodLocks /></ProtectedRoute>} />
          <Route path="/ps/closing/settlement" element={<ProtectedRoute><Settlement /></ProtectedRoute>} />
          <Route path="/ps/closing/wip" element={<ProtectedRoute><WIPCalculation /></ProtectedRoute>} />
          <Route path="/ps/closing/closure" element={<ProtectedRoute><ProjectClosure /></ProtectedRoute>} />
          <Route path="/ps/reports" element={<ProtectedRoute><PSReports /></ProtectedRoute>} />
          <Route path="/ps/investment-programs" element={<ProtectedRoute><InvestmentPrograms /></ProtectedRoute>} />
          <Route path="/ps/investment-programs/:programId" element={<ProtectedRoute><InvestmentProgramDetail /></ProtectedRoute>} />
          
          {/* PS-FI Integration */}
          <Route path="/ps/integration" element={<ProtectedRoute><PSFIDashboard /></ProtectedRoute>} />
          <Route path="/ps/integration/account-determination" element={<ProtectedRoute><AccountDetermination /></ProtectedRoute>} />
          <Route path="/ps/integration/fi-documents" element={<ProtectedRoute><FIDocuments /></ProtectedRoute>} />
          <Route path="/ps/integration/wip-posting" element={<ProtectedRoute><WIPPosting /></ProtectedRoute>} />
          
          {/* Manufacturing (PP) Module Routes */}
          <Route path="/manufacturing" element={<ProtectedRoute><ManufacturingDashboard /></ProtectedRoute>} />
          <Route path="/manufacturing/work-centers" element={<ProtectedRoute><WorkCenters /></ProtectedRoute>} />
          <Route path="/manufacturing/boms" element={<ProtectedRoute><BOMs /></ProtectedRoute>} />
          <Route path="/manufacturing/routings" element={<ProtectedRoute><Routings /></ProtectedRoute>} />
          <Route path="/manufacturing/number-ranges" element={<ProtectedRoute><MfgNumberRanges /></ProtectedRoute>} />
          <Route path="/manufacturing/production-orders" element={<ProtectedRoute><ProductionOrderList /></ProtectedRoute>} />
          <Route path="/manufacturing/production-orders/create" element={<ProtectedRoute><ProductionOrderForm /></ProtectedRoute>} />
          <Route path="/manufacturing/production-orders/:order_id" element={<ProtectedRoute><ProductionOrderDetail /></ProtectedRoute>} />
          
          <Route path="/vendor-master" element={<ProtectedRoute><VendorMaster /></ProtectedRoute>} />
          <Route path="/vendors" element={<ProtectedRoute><Vendors /></ProtectedRoute>} />
          <Route path="/vendors/create" element={<ProtectedRoute><VendorForm /></ProtectedRoute>} />
          <Route path="/vendors/:vendorNumber" element={<ProtectedRoute><VendorForm /></ProtectedRoute>} />
          <Route path="/material-master" element={<ProtectedRoute><MaterialMaster /></ProtectedRoute>} />
          <Route path="/customer-master" element={<ProtectedRoute><CustomerMaster /></ProtectedRoute>} />
          <Route path="/customer-account-group" element={<ProtectedRoute><CustomerAccountGroup /></ProtectedRoute>} />
          <Route path="/customer-number-range" element={<ProtectedRoute><CustomerNumberRange /></ProtectedRoute>} />
          <Route path="/customer-account-group-config" element={<ProtectedRoute><CustomerAccountGroupConfig /></ProtectedRoute>} />
          <Route path="/customer-partner-function" element={<ProtectedRoute><CustomerPartnerFunction /></ProtectedRoute>} />
          <Route path="/customer-account-group-partner-function" element={<ProtectedRoute><CustomerAccountGroupPartnerFunction /></ProtectedRoute>} />
          <Route path="/customer-partner-determination-procedure" element={<ProtectedRoute><CustomerPartnerDeterminationProcedure /></ProtectedRoute>} />
          <Route path="/customer-pdp-partner-function" element={<ProtectedRoute><CustomerPDPPartnerFunction /></ProtectedRoute>} />
          <Route path="/customer-account-group-pdp" element={<ProtectedRoute><CustomerAccountGroupPDP /></ProtectedRoute>} />
          <Route path="/customer-sales-district" element={<ProtectedRoute><CustomerSalesDistrict /></ProtectedRoute>} />
          <Route path="/customer-group" element={<ProtectedRoute><CustomerGroupPage /></ProtectedRoute>} />
          <Route path="/customer-delivery-priority" element={<ProtectedRoute><CustomerDeliveryPriority /></ProtectedRoute>} />
          <Route path="/customer-terms-of-payment" element={<ProtectedRoute><CustomerTermsOfPayment /></ProtectedRoute>} />
          <Route path="/customer-incoterms" element={<ProtectedRoute><CustomerIncoterms /></ProtectedRoute>} />
          <Route path="/customer-shipping-conditions" element={<ProtectedRoute><CustomerShippingConditions /></ProtectedRoute>} />
          <Route path="/customer-creation" element={<ProtectedRoute><CustomerCreation /></ProtectedRoute>} />
          <Route path="/view-customers" element={<ProtectedRoute><ViewCustomers /></ProtectedRoute>} />
          <Route path="/customer-view/:customerId" element={<ProtectedRoute><ViewCustomer /></ProtectedRoute>} />
          <Route path="/customer-edit/:customerId" element={<ProtectedRoute><EditCustomer /></ProtectedRoute>} />
          <Route path="/material-creation" element={<ProtectedRoute><MaterialCreation /></ProtectedRoute>} />
          <Route path="/view-materials" element={<ProtectedRoute><ViewMaterials /></ProtectedRoute>} />
          <Route path="/materials/view/:materialNumber" element={<ProtectedRoute><MaterialView /></ProtectedRoute>} />
          <Route path="/materials/edit/:materialNumber" element={<ProtectedRoute><MaterialEdit /></ProtectedRoute>} />
          <Route path="/material-details/:materialNumber" element={<ProtectedRoute><MaterialView /></ProtectedRoute>} />
          <Route path="/unit-of-measure" element={<ProtectedRoute><UnitOfMeasure /></ProtectedRoute>} />
          <Route path="/material-group" element={<ProtectedRoute><MaterialGroup /></ProtectedRoute>} />
          <Route path="/item-category-group" element={<ProtectedRoute><ItemCategoryGroup /></ProtectedRoute>} />
          <Route path="/weight-unit" element={<ProtectedRoute><WeightUnit /></ProtectedRoute>} />
          <Route path="/transportation-group" element={<ProtectedRoute><TransportationGroup /></ProtectedRoute>} />
          <Route path="/loading-group" element={<ProtectedRoute><LoadingGroup /></ProtectedRoute>} />
          <Route path="/availability-check" element={<ProtectedRoute><AvailabilityCheck /></ProtectedRoute>} />
          <Route path="/account-assignment-group" element={<ProtectedRoute><AccountAssignmentGroup /></ProtectedRoute>} />
          <Route path="/mrp-type" element={<ProtectedRoute><MRPType /></ProtectedRoute>} />
          <Route path="/mrp-controller" element={<ProtectedRoute><MRPController /></ProtectedRoute>} />
          <Route path="/lot-size" element={<ProtectedRoute><LotSize /></ProtectedRoute>} />
          <Route path="/lot-sizing-procedure" element={<ProtectedRoute><LotSizingProcedure /></ProtectedRoute>} />
          <Route path="/lot-size-indicator" element={<ProtectedRoute><LotSizeIndicator /></ProtectedRoute>} />
          <Route path="/procurement-type" element={<ProtectedRoute><ProcurementType /></ProtectedRoute>} />
          <Route path="/scheduling-margin-key" element={<ProtectedRoute><SchedulingMarginKey /></ProtectedRoute>} />
          <Route path="/period-indicator" element={<ProtectedRoute><PeriodIndicator /></ProtectedRoute>} />
          <Route path="/forecast-model" element={<ProtectedRoute><ForecastModel /></ProtectedRoute>} />
          <Route path="/selection-procedure" element={<ProtectedRoute><SelectionProcedure /></ProtectedRoute>} />
          <Route path="/task-list-usage" element={<ProtectedRoute><TaskListUsage /></ProtectedRoute>} />
          <Route path="/valuation-category" element={<ProtectedRoute><ValuationCategory /></ProtectedRoute>} />
          <Route path="/account-category-reference" element={<ProtectedRoute><AccountCategoryReference /></ProtectedRoute>} />
          <Route path="/valuation-type" element={<ProtectedRoute><ValuationType /></ProtectedRoute>} />
          <Route path="/valuation-type-category-assignment" element={<ProtectedRoute><ValuationTypeCategoryAssignment /></ProtectedRoute>} />
          <Route path="/valuation-class" element={<ProtectedRoute><ValuationClass /></ProtectedRoute>} />
          <Route path="/number-range" element={<ProtectedRoute><NumberRange /></ProtectedRoute>} />
          
          {/* P2P Routes */}
          <Route path="/p2p" element={<ProtectedRoute><P2PDashboard /></ProtectedRoute>} />
          <Route path="/p2p/dashboard" element={<ProtectedRoute><P2PDashboard /></ProtectedRoute>} />
          <Route path="/p2p/document-types" element={<ProtectedRoute><P2PDocumentTypes /></ProtectedRoute>} />
          <Route path="/p2p/number-ranges" element={<ProtectedRoute><NumberRanges /></ProtectedRoute>} />
          <Route path="/p2p/pr-create" element={<ProtectedRoute><PRCreateComplete /></ProtectedRoute>} />
          <Route path="/p2p/pr-create-complete" element={<ProtectedRoute><PRCreateComplete /></ProtectedRoute>} />
          <Route path="/p2p/pr-list" element={<ProtectedRoute><PRList /></ProtectedRoute>} />
          <Route path="/p2p/pr-view/:pr_number" element={<ProtectedRoute><PRView /></ProtectedRoute>} />
          <Route path="/p2p/pr-edit/:prNumber" element={<ProtectedRoute><PREdit /></ProtectedRoute>} />
          <Route path="/p2p/rfq-create" element={<ProtectedRoute><RFQCreateComplete /></ProtectedRoute>} />
          <Route path="/p2p/rfq-list" element={<ProtectedRoute><RFQList /></ProtectedRoute>} />
          <Route path="/p2p/rfq-view/:rfq_number" element={<ProtectedRoute><RFQView /></ProtectedRoute>} />
          <Route path="/p2p/rfq-edit/:rfq_number" element={<ProtectedRoute><RFQEdit /></ProtectedRoute>} />
          <Route path="/p2p/po-list" element={<ProtectedRoute><POList /></ProtectedRoute>} />
          <Route path="/p2p/po-view/:poNumber" element={<ProtectedRoute><POViewComplete /></ProtectedRoute>} />
          <Route path="/p2p/po-create" element={<ProtectedRoute><POCreateComplete /></ProtectedRoute>} />
          <Route path="/p2p/po-edit/:poNumber" element={<ProtectedRoute><POEdit /></ProtectedRoute>} />
          <Route path="/p2p/gr-list" element={<ProtectedRoute><GRList /></ProtectedRoute>} />
          <Route path="/p2p/gr-view/:material_document/:fiscal_year" element={<ProtectedRoute><GRView /></ProtectedRoute>} />
          <Route path="/p2p/gr-create" element={<ProtectedRoute><GRCreate /></ProtectedRoute>} />
          <Route path="/p2p/ir-list" element={<ProtectedRoute><IRList /></ProtectedRoute>} />
          <Route path="/p2p/ir-view/:invoice_document/:fiscal_year" element={<ProtectedRoute><IRView /></ProtectedRoute>} />
          <Route path="/p2p/ir-create" element={<ProtectedRoute><IRCreate /></ProtectedRoute>} />
          
          {/* Service Entry Sheet Routes */}
          <Route path="/p2p/ses-list" element={<ProtectedRoute><SESList /></ProtectedRoute>} />
          <Route path="/p2p/ses-view/:entry_sheet_number/:fiscal_year" element={<ProtectedRoute><SESView /></ProtectedRoute>} />
          <Route path="/p2p/ses-create" element={<ProtectedRoute><SESCreate /></ProtectedRoute>} />
          
          {/* Inventory Management Routes */}
          <Route path="/inventory" element={<ProtectedRoute><InventoryDashboard /></ProtectedRoute>} />
          <Route path="/inventory/dashboard" element={<ProtectedRoute><InventoryDashboard /></ProtectedRoute>} />
          <Route path="/inventory/stock-overview" element={<ProtectedRoute><StockOverview /></ProtectedRoute>} />
          <Route path="/inventory/material-documents" element={<ProtectedRoute><MaterialDocuments /></ProtectedRoute>} />
          <Route path="/inventory/initial-stock" element={<ProtectedRoute><InitialStockPosting /></ProtectedRoute>} />
          <Route path="/inventory/stock-transfer" element={<ProtectedRoute><StockTransfer /></ProtectedRoute>} />
          <Route path="/inventory/grir-reconciliation" element={<ProtectedRoute><GRIRReconciliation /></ProtectedRoute>} />
          <Route path="/inventory/accounting-documents" element={<ProtectedRoute><AccountingDocuments /></ProtectedRoute>} />
          
          {/* Pricing / SD Routes */}
          <Route path="/pricing/condition-types" element={<ProtectedRoute><ConditionTypes /></ProtectedRoute>} />
          <Route path="/pricing/condition-records" element={<ProtectedRoute><ConditionRecords /></ProtectedRoute>} />
          <Route path="/pricing/simulator" element={<ProtectedRoute><PricingSimulator /></ProtectedRoute>} />
          <Route path="/pricing/access-sequences" element={<ProtectedRoute><AccessSequences /></ProtectedRoute>} />
          <Route path="/pricing/condition-tables" element={<ProtectedRoute><ConditionTables /></ProtectedRoute>} />
          <Route path="/pricing/pricing-procedures" element={<ProtectedRoute><PricingProcedures /></ProtectedRoute>} />
          
          {/* Order-to-Cash (OTC) Routes */}
          <Route path="/otc/dashboard" element={<ProtectedRoute><OTCDashboard /></ProtectedRoute>} />
          <Route path="/otc/sales-orders" element={<ProtectedRoute><SalesOrderList /></ProtectedRoute>} />
          <Route path="/otc/sales-orders/create" element={<ProtectedRoute><SalesOrderCreate /></ProtectedRoute>} />
          <Route path="/otc/sales-orders/:salesOrderNumber" element={<ProtectedRoute><SalesOrderView /></ProtectedRoute>} />
          <Route path="/otc/deliveries" element={<ProtectedRoute><DeliveryList /></ProtectedRoute>} />
          <Route path="/otc/deliveries/create" element={<ProtectedRoute><DeliveryCreate /></ProtectedRoute>} />
          <Route path="/otc/deliveries/:deliveryNumber" element={<ProtectedRoute><DeliveryView /></ProtectedRoute>} />
          <Route path="/otc/billing" element={<ProtectedRoute><BillingList /></ProtectedRoute>} />
          <Route path="/otc/billing/create" element={<ProtectedRoute><BillingCreate /></ProtectedRoute>} />
          <Route path="/otc/billing/:billingNumber" element={<ProtectedRoute><BillingView /></ProtectedRoute>} />
          
          {/* Accounts Receivable (AR) Routes */}
          <Route path="/ar/open-items" element={<ProtectedRoute><CustomerOpenItems /></ProtectedRoute>} />
          <Route path="/ar/payments" element={<ProtectedRoute><PaymentList /></ProtectedRoute>} />
          <Route path="/ar/payments/create" element={<ProtectedRoute><PaymentCreate /></ProtectedRoute>} />
          <Route path="/ar/payments/:paymentNumber" element={<ProtectedRoute><PaymentView /></ProtectedRoute>} />
          <Route path="/ar/aging-report" element={<ProtectedRoute><ARAgingReport /></ProtectedRoute>} />
          
          {/* Credit Management Routes */}
          <Route path="/otc/credit-exposure" element={<ProtectedRoute><CreditExposure /></ProtectedRoute>} />
          <Route path="/otc/credit-management/:customerId" element={<ProtectedRoute><CustomerCreditView /></ProtectedRoute>} />
          <Route path="/otc/atp-check" element={<ProtectedRoute><ATPCheck /></ProtectedRoute>} />
          
          {/* Returns & Credit Memos Routes */}
          <Route path="/otc/returns" element={<ProtectedRoute><ReturnsOrderList /></ProtectedRoute>} />
          <Route path="/otc/returns/create" element={<ProtectedRoute><ReturnsOrderCreate /></ProtectedRoute>} />
          <Route path="/otc/returns/:returnsNumber" element={<ProtectedRoute><ReturnsOrderView /></ProtectedRoute>} />
          <Route path="/otc/credit-memos" element={<ProtectedRoute><CreditMemoList /></ProtectedRoute>} />
          <Route path="/otc/credit-memos/:creditMemoNumber" element={<ProtectedRoute><CreditMemoView /></ProtectedRoute>} />
          
          {/* Pre-Sales Routes */}
          <Route path="/presales/inquiries" element={<ProtectedRoute><InquiryList /></ProtectedRoute>} />
          <Route path="/presales/inquiries/create" element={<ProtectedRoute><InquiryCreate /></ProtectedRoute>} />
          <Route path="/presales/inquiries/:inquiryNumber" element={<ProtectedRoute><InquiryView /></ProtectedRoute>} />
          <Route path="/presales/inquiries/:inquiryNumber/edit" element={<ProtectedRoute><InquiryEdit /></ProtectedRoute>} />
          <Route path="/presales/quotations" element={<ProtectedRoute><QuotationList /></ProtectedRoute>} />
          <Route path="/presales/quotations/create" element={<ProtectedRoute><QuotationCreate /></ProtectedRoute>} />
          <Route path="/presales/quotations/:quotationNumber" element={<ProtectedRoute><QuotationView /></ProtectedRoute>} />
          <Route path="/presales/quotations/:quotationNumber/edit" element={<ProtectedRoute><QuotationEdit /></ProtectedRoute>} />
          
          {/* Accounts Payable (AP) Routes */}
          <Route path="/ap/payments" element={<ProtectedRoute><VendorPaymentList /></ProtectedRoute>} />
          <Route path="/ap/payments/:payment_number" element={<ProtectedRoute><VendorPaymentView /></ProtectedRoute>} />
          <Route path="/ap/payment-proposal" element={<ProtectedRoute><PaymentProposalCreate /></ProtectedRoute>} />
          <Route path="/ap/open-items" element={<ProtectedRoute><VendorOpenItems /></ProtectedRoute>} />
          <Route path="/ap/aging" element={<ProtectedRoute><APAgingReport /></ProtectedRoute>} />
          
          {/* P2 - Vendor Quotation Routes */}
          <Route path="/vendor-quotes" element={<ProtectedRoute><VendorQuotationList /></ProtectedRoute>} />
          <Route path="/vendor-quotes/comparison/:rfq_number" element={<ProtectedRoute><QuoteComparisonView /></ProtectedRoute>} />
          
          {/* P2 - Release Strategy Routes */}
          <Route path="/release/strategies" element={<ProtectedRoute><ReleaseStrategyList /></ProtectedRoute>} />
          <Route path="/release/inbox" element={<ProtectedRoute><ApprovalInbox /></ProtectedRoute>} />
          
          {/* P2 - Vendor Returns Routes */}
          <Route path="/vendor-returns" element={<ProtectedRoute><VendorReturnList /></ProtectedRoute>} />
          <Route path="/vendor-returns/create" element={<ProtectedRoute><VendorReturnCreate /></ProtectedRoute>} />
          <Route path="/vendor-returns/:returnNumber" element={<ProtectedRoute><VendorReturnDetail /></ProtectedRoute>} />
          
          {/* P2 - Warehouse Shipping Routes */}
          <Route path="/warehouse/shipments" element={<ProtectedRoute><ShipmentList /></ProtectedRoute>} />
          <Route path="/warehouse/shipments/create" element={<ProtectedRoute><ShipmentCreate /></ProtectedRoute>} />
          <Route path="/warehouse/shipments/:shipmentNumber" element={<ProtectedRoute><ShipmentView /></ProtectedRoute>} />
          <Route path="/warehouse/pick-lists" element={<ProtectedRoute><PickListPage /></ProtectedRoute>} />
          <Route path="/warehouse/pick-lists/create" element={<ProtectedRoute><PickListCreate /></ProtectedRoute>} />
          <Route path="/warehouse/pick-lists/:pickListNumber" element={<ProtectedRoute><PickListView /></ProtectedRoute>} />
          <Route path="/warehouse/packing" element={<ProtectedRoute><PackingPage /></ProtectedRoute>} />
          
          {/* OTC Enhancement Routes */}
          <Route path="/otc/billing-blocks" element={<ProtectedRoute><BillingBlocksPage /></ProtectedRoute>} />
          <Route path="/otc/sales-performance" element={<ProtectedRoute><SalesPerformancePage /></ProtectedRoute>} />
          <Route path="/otc/profitability" element={<ProtectedRoute><ProfitabilityPage /></ProtectedRoute>} />
          <Route path="/otc/milestone-billing" element={<ProtectedRoute><MilestoneBillingPage /></ProtectedRoute>} />
          <Route path="/otc/intercompany-billing" element={<ProtectedRoute><IntercompanyBillingPage /></ProtectedRoute>} />
          <Route path="/warehouse/wave-picking" element={<ProtectedRoute><WavePickingPage /></ProtectedRoute>} />
          <Route path="/warehouse/pod" element={<ProtectedRoute><PODPage /></ProtectedRoute>} />
          <Route path="/warehouse/routes" element={<ProtectedRoute><RouteSchedulingPage /></ProtectedRoute>} />
        </Routes>
        <Toaster />
        <HotToaster position="top-right" />
      </div>
      </CopilotProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
